module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/thumbs/5-c938a8cc16495b85e2db78271b389d51.webp";